<div class="price_part_lookz" *ngIf="!loader">
    <div class="create_opl">
        <sm-title-bar pageTitle="Current pack" [backWithAllParams]="true"></sm-title-bar>
           <div class="likely_section">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="choose_sucri">
                            <mat-card appearance="outlined" *ngIf="currentPlan.length > 0">
                            <div class="nus_nu_sectionm">
                                <div class="create_thy">
                                    <h1>Active employee subscription</h1>
                                    <h3>{{currentPlan[0].planName}}</h3>
                                    <p>{{currentPlan[0].description}}</p>
                                </div>
                                <div class="current_pack_rec">
                                    <div class="progress-bar">
                                        <div class="progress-circle active bhy_md">
                                          <div class="progress-circle-dot-container">
                                            <div class="progress-circle-dot"></div>
                                          </div>
                                        </div>
                                        <div class="progress-circle active bhy_sd">
                                          <div class="progress-circle-dot-container">
                                            <div class="progress-circle-dot"></div>
                                          </div>
                                        </div>
                                        <div id="progress-line" class="progress-line"></div>
                                      </div>
                                      <div class="curr_seci">
                                <h4>Valid From: {{currentPlan[0].fromDate | date}}</h4>
                                <h4>Valid till: {{currentPlan[0].toDate | date}}</h4>
                            </div>
                               </div>

                                <div class="secr_check_secu">
                                    <p><span class="grren_tht"><mat-icon>task_alt</mat-icon> Active </span></p>
                                </div>
                                <div class="sed_button">
                                    <button flat type="button" (click)="goToRenew()">Recharge pack</button>
                                </div>
                            </div>
                        </mat-card>

                        <!-- Placeholder card start -->
                            <div class="placeholder_subsc" *ngIf="currentPlan.length == 0">
                            <mat-card appearance="outlined">
                                <div class="business_icons">
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g data-name="Ebene 2"><path d="M243.93 320a10.73 10.73 0 0 0 12.44-8.54 58.9 58.9 0 0 0 1.08-11c0-25.24-15.83-47.15-38.84-57.81a47.08 47.08 0 0 0 16.06-35.38c0-26.16-21.53-47.44-48-47.44s-48 21.28-48 47.44A47.11 47.11 0 0 0 155 242.89c-22.77 10.73-38.4 32.51-38.4 57.59a60.19 60.19 0 0 0 1.07 10.95 10.68 10.68 0 0 0 10.48 8.73 9.87 9.87 0 0 0 1.94-.18 10.67 10.67 0 0 0 8.56-12.43 39.21 39.21 0 0 1-.72-7.07c0-23.92 22-43.37 49.11-43.37s49.1 19.45 49.1 43.37a38.59 38.59 0 0 1-.72 7.06 10.66 10.66 0 0 0 8.51 12.46zm-57.26-138.8c14.7 0 26.67 11.72 26.67 26.11s-12 26.12-26.67 26.12S160 221.69 160 207.29s12-26.11 26.67-26.11zM378.05 177.46l-70.47 68.76L283 221.61a10.67 10.67 0 0 0-15.09 15.08l39.51 39.51 85.55-83.47a10.66 10.66 0 0 0-14.89-15.27z" fill="#656565" opacity="1" data-original="#000000" class=""></path><path d="M437.34 181.34A10.67 10.67 0 0 0 448 170.67v-32A42.71 42.71 0 0 0 405.34 96H106.67A42.72 42.72 0 0 0 64 138.67v202.67A42.71 42.71 0 0 0 106.67 384h82.14a10.63 10.63 0 0 1 7.55 3.13l44.55 44.55a21.34 21.34 0 0 0 30.18 0l44.55-44.55a10.74 10.74 0 0 1 7.54-3.13h82.16A42.71 42.71 0 0 0 448 341.34V224a10.67 10.67 0 0 0-21.33 0v117.34a21.36 21.36 0 0 1-21.33 21.33h-82.16a31.79 31.79 0 0 0-22.62 9.33L256 416.6 211.44 372a31.8 31.8 0 0 0-22.63-9.37h-82.14a21.35 21.35 0 0 1-21.33-21.33V138.67a21.35 21.35 0 0 1 21.33-21.33h298.67a21.36 21.36 0 0 1 21.33 21.33v32a10.67 10.67 0 0 0 10.67 10.67z" fill="#656565" opacity="1" data-original="#000000" class=""></path></g></g></svg>
                                </div>
                                <h3>No employee paid pack added
                                </h3>
                                <p>This employee is without a paid pack. He/she wouldn't be able to access app functionality anymore.</p>
                                <div class="sed_button">
                                    <button flat type="button" (click)="goToRenew()">Recharge employee</button>
                                </div>
                            </mat-card>
                            </div>
                        <!-- Placeholder card end -->


                        </div>
                    </div>
                    <div class="col-sm-8">
                        
                        <div class="create_employees_ben">
                            <mat-card appearance="outlined">
                            <div class="wht_headinght">
                                <h3>Accessible feature and functionality</h3>
                                <p>Here's the list of operations your employee can perform from the existing pack. Functionality with green tick are open to access in the current business.</p>
                            </div>
                            <div class="assistant_benf">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="cardfg_se">
                                            <mat-icon *ngIf="currentPlan.length > 0">check</mat-icon>
                                            <mat-icon *ngIf="currentPlan.length == 0" style="color: #e60505;">close</mat-icon>
                                            Duty hours log with location

                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="cardfg_se">
                                            <mat-icon *ngIf="currentPlan.length > 0">check</mat-icon>
                                            <mat-icon *ngIf="currentPlan.length == 0" style="color: #e60505;">close</mat-icon>
                                            Booking and query add

                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="cardfg_se">
                                            <mat-icon *ngIf="currentPlan.length > 0">check</mat-icon>
                                            <mat-icon *ngIf="currentPlan.length == 0" style="color: #e60505;">close</mat-icon>
                                            Customer service/operations
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="cardfg_se">
                                            <mat-icon *ngIf="currentPlan.length > 0">check</mat-icon>
                                            <mat-icon *ngIf="currentPlan.length == 0" style="color: #e60505;">close</mat-icon>
                                            Bill/Invoice generation

                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="cardfg_se">
                                              <mat-icon *ngIf="currentPlan.length > 0">check</mat-icon>
                                            <mat-icon *ngIf="currentPlan.length == 0" style="color: #e60505;">close</mat-icon>
                                            Purchase reminder set 

                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="cardfg_se">
                                              <mat-icon *ngIf="currentPlan.length > 0">check</mat-icon>
                                            <mat-icon *ngIf="currentPlan.length == 0" style="color: #e60505;">close</mat-icon>
                                            Purchase record add 

                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="cardfg_se">
                                              <mat-icon *ngIf="currentPlan.length > 0">check</mat-icon>
                                            <mat-icon *ngIf="currentPlan.length == 0" style="color: #e60505;">close</mat-icon>
                                            Inventory item use update


                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="cardfg_se">
                                              <mat-icon *ngIf="currentPlan.length > 0">check</mat-icon>
                                            <mat-icon *ngIf="currentPlan.length == 0" style="color: #e60505;">close</mat-icon>
                                            Advance payment/credit track


                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="cardfg_se">
                                              <mat-icon *ngIf="currentPlan.length > 0">check</mat-icon>
                                            <mat-icon *ngIf="currentPlan.length == 0" style="color: #e60505;">close</mat-icon>
                                            Real time update


                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="cardfg_se">
                                              <mat-icon *ngIf="currentPlan.length > 0">check</mat-icon>
                                            <mat-icon *ngIf="currentPlan.length == 0" style="color: #e60505;">close</mat-icon>
                                            Communication via messaging






                                        </div>
                                    </div>
                                </div>
                            </div>
                            </mat-card>
                        </div>
                    </div>
               
                    
                </div>
        </div>
    </div>
</div>
